import { vars } from '@etg/wings';
import { css, cx, etiColors, mediaQueries } from '@eti/styles';
import ProductIcon from './ProductIcon';
import ProductImageryContent from './ProductImageryContent';
import { jsx as _jsx } from "react/jsx-runtime";
const wrapperStyles = css`
  margin-inline-end: 0.625rem;
  position: relative;

  @media (min-width: 48em) {
    flex-shrink: 0;
    margin: 0;
  }
`;
const Wrapper = props => /*#__PURE__*/_jsx("div", {
  className: wrapperStyles,
  ...props
});
const imageContainerStyles = image => css`
  background: ${etiColors.grayScale[2]} url('${image}') no-repeat center;
  background-size: 100px 100px;
  height: 100px;
  width: 100px;

  @media ${mediaQueries.medium.up} {
    background-position: top;
    background-size: cover;
    border-bottom-left-radius: ${vars.card.borderRadius};
    border-top-left-radius: ${vars.card.borderRadius};
    height: 100%;
    width: 100%;
  }

  [dir='rtl'] & {
    @media ${mediaQueries.medium.up} {
      border-radius: ${vars.card.borderRadius} 0 ${vars.card.borderRadius} 0;
    }
  }
`;
const ImageContainer = _ref => {
  let {
    className,
    image,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: cx(imageContainerStyles(image), className),
    ...rest
  });
};
const iconStyles = css`
  height: 40px;
  left: 6px;
  position: absolute;
  top: 6px;
  width: 40px;

  @media (min-width: 48em) {
    height: 50px;
    left: 16px;
    top: 16px;
    width: 50px;
  }

  [dir='rtl'] & {
    left: 0;
    right: 6px;

    @media (min-width: 48em) {
      left: 0;
      right: 16px;
    }
  }
`;
const Icon = _ref2 => {
  let {
    className,
    ...rest
  } = _ref2;
  return /*#__PURE__*/_jsx(ProductIcon, {
    className: cx(iconStyles, className),
    ...rest
  });
};
const ProductImagery = _ref3 => {
  let {
    iconName,
    productName
  } = _ref3;
  return /*#__PURE__*/_jsx(ProductImageryContent, {
    displayElements: {
      ImageContainer,
      Icon,
      Wrapper
    },
    iconName: iconName,
    productName: productName
  });
};
export default ProductImagery;
//# sourceMappingURL=ProductImagery.js.map